import { render } from "./ResetPwd.vue?vue&type=template&id=3d811b3c&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"

import "./ResetPwd.vue?vue&type=style&index=0&id=3d811b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d811b3c"]])

export default __exports__